import {Col, Flex, Row, Tooltip} from "antd";
import React from "react";
import {useTranslation} from "react-i18next";

export const MarkBasic = React.memo(({item, mark, index, handleClickMark, record, column}: any) => {
  const {t} = useTranslation("common")

  return (
    <Tooltip destroyTooltipOnHide title={(
      mark.theme && <Row>
        <Col span={24}>
          {t('theme')}: {mark.theme}
        </Col>
      </Row>
    )}>
      <Flex
        key={`${item?.type}-button-${mark?.key}-${index}`}
        onClick={() => mark?.isEdit ? handleClickMark(mark, record, column) : {}}
        style={{
          backgroundColor: mark?.['background-color'] || 'rgba(255,255,255, 0.8)',
          cursor: mark?.isEdit ? 'pointer' : 'default',
          border: `1px solid ${mark?.['border-color'] || `#d9d9d9`}`,
          flexDirection: 'column',
          width: 50,
          height: 50,
          borderRadius: 8,
          overflow: 'hidden'
        }}
        justify='center'
        align='center'
      >
        {mark?.mark}
      </Flex>
    </Tooltip>
  )
})